'use strict';

$ = jQuery;

$('#jc-image-catalog-slider').slick({
  nextArrow: '#jc-image-catalog-slider-next',
  prevArrow: '#jc-image-catalog-slider-prev',
  dots: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});